module.exports = __webpack_public_path__ + "img/trash-fill.e6a4b98d.svg";